import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import Cookies from "cookies-js";
import * as queryString from 'query-string';

class NavigateParent extends React.Component {


    componentDidMount() {
        if (typeof window !== "undefined") {
            if (typeof window.parent !== "undefined") {
                if (window !== window.top) {
                    const { location } = this.props;
                    //debugger;
                    const query = location.search ? queryString.parse(location.search) : location.query;
                    //Jball (2019.01.18:  Need to add andylitics call to log a delegate failure.)
                    //debugger;
                    //if (query) {
                    //    if (typeof query.context!=="undefined")
                    //        alert(query.context);
                    //    if (typeof query.msg !== "undefined")
                    //        alert(query.msg);
                    //    if (typeof query.status !== "undefined")
                    //        alert(query.status);                    
                    //}
                    //debugger;
                    if (window.top.location.pathname !== "/login") {
                        window.top.location = '/';
                    }
                }
            }
        }        
    }
        

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    componentWillUnmount() {
    }   

    render() {
        return (
            <div className="section-error-container">
                <div className="row">
                    <div className="col-12 align-self-center">
                        <div className="row section-error__body">
                            <div className="col-12">
                                <div className="section-error__body--message">
                                    <span className="icon-info" /> We need to refresh your session. Please bear with us.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    var oProps = {        
    };

    return oProps;
}

const mapDispatchToProps = (dispatch) => {
    return {  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigateParent);